import { useMutation } from '@apollo/client/react';
import { toast } from 'sonner';

import { DELETE_APPENDIX } from './constants';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/components/ui/alert-dialog';
import { Spinner } from '@/components/ui/spinner';

interface DeleteAppendixDialogProps {
  appendixId: string;
  onClose: () => void;
  onSuccess: () => void;
  open: boolean;
}

const DeleteAppendixDialog = ({
  appendixId,
  onClose,
  onSuccess,
  open
}: DeleteAppendixDialogProps) => {
  const [deleteAppendix, { loading: isDeleting }] = useMutation(
    DELETE_APPENDIX,
    {
      onCompleted: () => {
        toast.success('Appendix deleted successfully');
        onSuccess();
        onClose();
      },
      onError: () => {
        toast.error('Failed to delete appendix');
      }
    }
  );

  const handleDelete = () => {
    void deleteAppendix({
      variables: {
        id: appendixId
      }
    });
  };

  return (
    <AlertDialog
      onOpenChange={onClose}
      open={open}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Appendix</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this appendix? This action cannot be
            undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={isDeleting}
            onClick={handleDelete}
            variant="destructive"
          >
            {isDeleting && <Spinner />}
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteAppendixDialog;
